import { useForm } from 'react-hook-form';

import { CNMCForm, CNMCStateEnum } from '../types';

export function useCNMCDrawerFormState() {
  const initialValues: Partial<CNMCForm> = {
    description: '',
    recipients: '',
    name: '',
    channel: '',
    provider: '',
    start_datetime: new Date(),
    end_datetime: new Date(),
    state: CNMCStateEnum.DRAFT,
  };
  const form = useForm<CNMCForm>({
    mode: 'all',
    defaultValues: initialValues,
  });

  return { form, initialValues };
}
